export default function OrderListIcon({ className }: any) {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M21 16.3335L30.3333 16.3335" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
      <path d="M21 35L28 35" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
      <path d="M21 25.6665L35 25.6665" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
      <path
        d="M44.3327 25.6667V13C44.3327 10.1716 44.3327 8.75736 43.454 7.87868C42.5753 7 41.1611 7 38.3327 7H17.666C14.8376 7 13.4234 7 12.5447 7.87868C11.666 8.75736 11.666 10.1716 11.666 13V43C11.666 45.8284 11.666 47.2426 12.5447 48.1213C13.4234 49 14.8376 49 17.666 49H27.9993"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <circle cx="40.8333" cy="40.8333" r="5.83333" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
      <path d="M49 49L45.5 45.5" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
    </svg>
  );
}
